// Dashboard.js
import React from "react";
import Navbar from "./Navbar";
import Main from "./main";

const Dashboard = () => {
  return (
    <div>
      <Navbar />
      <Main />
    </div>
  );
};

export default Dashboard;
